"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
}); // src/definitions/constants.ts
var Constants = /* @__PURE__ */ function(Constants2) {
    Constants2["AuthorizePath"] = "/oauth2/v1/authorize";
    Constants2["CodeChallengeMethod"] = "S256";
    Constants2["ServerTokenPath"] = "/oauth2/v1/token";
    Constants2["GrantType"] = "authorization_code";
    Constants2["Code"] = "code";
    Constants2["Headers"] = "headers";
    return Constants2;
}(Constants || {});
var errorMessages = {
    AUTH_CODE_VERIFIER_KEY_NOT_FOUND: "authCodeVerifierKey is not found in sessionStorage.",
    EMPTY_STRING: "Property validation failed: empty string.",
    ENVIRONMENT_NOT_PRESENT: "Environment value is missing.",
    GET_PROFILE_CALL_ERROR: "Error while get profile call for pcid : ",
    DECODE_JWT_ERROR: "Error while decoding the jwt ",
    INVALID_1XX_ERRORS: "Invalid 1xx Errors.",
    INVALID_3XX_ERRORS: "Invalid 3xx Errors.",
    INVALID_4XX_ERRORS: "Invalid 4xx Errors.",
    INVALID_5XX_ERRORS: "Invalid 5xx Errors.",
    INVALID_ID_TOKEN: "id_token must be a string.",
    INVALID_CSRF_DOES_NOT_MATCH: "The received csrf doesn't match with the stored csrf reference.",
    INVALID_NONCE_DOES_NOT_MATCH: "The given [nonce] string doesn't match with the stored nonce reference.",
    INVALID_NONCE_JWT_PAYLOAD: "Invalid or missing nonce in JWT payload.",
    INVALID_STRING: "Invalid string.",
    INVALID_URL: "URL validation failed: The URL is invalid or malformed. It should follow this pattern: ^(http|https):\\/\\/[^\\s$.?#].[^\\s]*$",
    JWT_VALIDATION_FAILED: "JWT validation has failed.",
    MISSING_ACCESS_TOKEN_RESPONSE_KEY: "Missing access token response key",
    MISSING_CODE_PARAM_ERROR: "[code] param is missing in the search url.",
    MISSING_EXPIRES_IN_RESPONSE_KEY: "Missing expires in response key",
    MISSING_REFRESH_TOKEN_RESPONSE_KEY: "Missing refresh token response key",
    MISSING_STATE_PARAM_ERROR: "[state] param is missing in the search url.",
    MISSING_TOKEN_TYPE_RESPONSE_KEY: "Missing token type response key",
    NOT_A_FUNCTION_ERROR: "Applied validator on a property that's not a method",
    UNDEFINED_PROPERTY: "Property validation failed: undefined property."
};
exports.Constants = Constants;
exports.errorMessages = errorMessages;
